import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { CONTACT_EMAIL, CONTACT_PHONE_DISPLAY, OFFICE_ADDRESS } from "@/lib/contact";

const SECTIONS = [
  {
    title: "1. Acceptance of Terms",
    body: "By accessing EONFAIRFOX.IN, you agree to these Terms of Use. If you do not agree, please do not use this website. This website is operated by Homewiz.in as an independent marketing and investment advisory desk.",
  },
  {
    title: "2. Nature of This Website",
    body: "EONFAIRFOX.IN is an independent marketing and investment advisory website operated by Homewiz.in. It is not the official website of Fairfox IT Infra Pvt. Ltd. Project names, RERA numbers and development details refer to the Fairfox EON project and are presented for advisory and marketing purposes.",
  },
  {
    title: "3. No Guaranteed Returns",
    body: "All prices, rental figures, yields, ROI calculations and appreciation projections shown on this website — including the investment calculator and comparison tables — are indicative only and do not constitute a guarantee of returns, rentals or capital appreciation. Real estate investments carry risk; verify all figures independently before committing funds.",
  },
  {
    title: "4. Accuracy of Information",
    body: "Pricing, availability, unit sizes, payment plans and project specifications are subject to change without notice and to final confirmation by the developer. Competitor project information is drawn from public listings and market guidance and may be outdated. Nothing on this website constitutes a binding offer.",
  },
  {
    title: "5. Enquiries & Communication",
    body: "Submitting an enquiry or tapping a WhatsApp, email or call button authorises our investment desk to contact you regarding your requirement. Advisory assistance for buying, fit-out and leasing is provided on a best-efforts basis and does not create an agency, partnership or fiduciary relationship unless separately agreed in writing.",
  },
  {
    title: "6. Intellectual Property",
    body: "Site design, copy and the Homewiz.in brand elements are the property of Homewiz.in. Project renders and project names remain the property of their respective developers. No content may be reproduced without written permission.",
  },
  {
    title: "7. Third-Party Services & Links",
    body: "This website uses Google Tag Manager, Google Maps, WhatsApp and Instagram services, each governed by their own terms and privacy policies. We are not responsible for the content or practices of third-party platforms.",
  },
  {
    title: "8. Limitation of Liability",
    body: "To the fullest extent permitted by law, Homewiz.in shall not be liable for any direct, indirect or consequential loss arising from reliance on information presented on this website or from investment decisions made based on it.",
  },
  {
    title: "9. Governing Law",
    body: "These terms are governed by the laws of India. Any disputes shall be subject to the exclusive jurisdiction of the courts at Gautam Buddh Nagar, Uttar Pradesh.",
  },
  {
    title: "10. Contact",
    body: `Homewiz.in — Independent Marketing & Investment Advisory. Email: ${CONTACT_EMAIL} · Phone / WhatsApp: ${CONTACT_PHONE_DISPLAY} · Our investment desk: ${OFFICE_ADDRESS.full}. Last updated: October 2026.`,
  },
];

export default function Terms() {
  return (
    <div className="min-h-screen bg-[#0B0C0E] text-[#F3F4F6] font-body antialiased">
      <header className="border-b border-white/[0.07] bg-[#0B0C0E]/90 backdrop-blur-xl sticky top-0 z-40">
        <div className="max-w-4xl mx-auto px-5 sm:px-8 h-[72px] flex items-center justify-between">
          <Logo />
          <Link
            to="/"
            data-testid="terms-back-link"
            className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#9CA3AF] hover:text-[#D4AF37] transition-colors duration-300"
          >
            ← Back to Site
          </Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-5 sm:px-8 py-16 sm:py-20">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
        >
          <p data-testid="terms-operator-disclosure" className="font-mono text-xs uppercase tracking-[0.35em] text-[#D4AF37]">Homewiz.in · Independent EON Fairfox Investment Desk</p>
          <h1 data-testid="terms-title" className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-[#F3F4F6]">
            Terms of <span className="gold-text italic">Use.</span>
          </h1>
          <p className="mt-4 text-sm text-[#9CA3AF]">Last updated: October 2026</p>
        </motion.div>

        <div className="mt-12 space-y-8">
          {SECTIONS.map((s, i) => (
            <motion.section
              key={s.title}
              data-testid={`terms-section-${i + 1}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: 0.05 * i, ease: [0.16, 1, 0.3, 1] }}
              className="rounded-2xl border border-white/[0.07] bg-[#121418] p-7"
            >
              <h2 className="font-display text-xl font-semibold text-[#F3E5AB]">{s.title}</h2>
              <p className="mt-3 text-sm text-[#9CA3AF] leading-relaxed">{s.body}</p>
            </motion.section>
          ))}
        </div>
      </main>
    </div>
  );
}
